import React from 'react';
import './Sub-services.css'; // Importa los estilos CSS para este componente
import RedesBaja from './assets/Iluminacion.png';
const EstudiosIluminacionContent = () => {
  return (
    <div className="containerSer">
      <h2>Estudios de Iluminación</h2>
      <p>
        Los estudios de iluminación son análisis técnicos que permiten diseñar
        sistemas de iluminación óptimos para espacios residenciales,
        comerciales, industriales o públicos. Se busca garantizar niveles
        adecuados de iluminación según el uso del espacio, cumpliendo con
        normativas aplicables, mejorando la eficiencia energética y la comodidad
        visual.
      </p>

      <div className="image">
        <img src={RedesBaja} alt="Estudios de iluminación" />
      </div>

      <p>
        Ofrecemos el servicio de estudios de iluminación para proyectos nuevos o
        en operación, asegurando niveles óptimos de luz, eficiencia energética y
        cumplimiento con el Reglamento Técnico de Iluminación y Alumbrado
        Público (RETILAP); este servicio incluye: diagnóstico del espacio y
        análisis del uso, diseño lumínico con software especializado; cálculo de
        niveles de iluminancia y distribución lumínica, selección de luminarias
        eficientes (LED o especializadas); planos, memorias técnicas y soporte
        normativo; acompañamiento en instalación y verificación final.
      </p>
      <h3>Beneficios clave:</h3>
      <ul>
        <li>Comodidad visual para usuarios y trabajadores.</li>
        <li>Ahorro energético a través de soluciones eficientes.</li>
        <li>Cumplimiento de normativas RETILAP y exigencias legales.</li>
        <li>
          Ambiente más seguro y funcional para las personas que ocupen cada
          espacio.
        </li>
        <li>Tranquilidad al contar con respaldo técnico experto.</li>
      </ul>
    </div>
  );
};

export default EstudiosIluminacionContent;
